var map = {
	"./decidim/avatar-multiuser.png": 53123,
	"./decidim/brands/google.svg": 60098,
	"./decidim/cc-badge.png": 10145,
	"./decidim/decidim-logo.svg": 70289,
	"./decidim/default-avatar.svg": 88305,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 62695,
	"./decidim/icons.svg": 49872,
	"./decidim/pattern.png": 3059,
	"./decidim/placeholder-card-g.svg": 68048,
	"./decidim/placeholder-card-l.svg": 78107,
	"./decidim/placeholder.jpg": 13810,
	"./decidim/remixicon.symbol.svg": 69512,
	"./decidim/vendor/leaflet/layers-2x.png": 60385,
	"./decidim/vendor/leaflet/layers.png": 69480,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 41785,
	"./decidim/vendor/leaflet/marker-icon.png": 816,
	"./decidim/vendor/leaflet/marker-shadow.png": 95855,
	"./decidim/vendor/social-share-button/douban.svg": 98971,
	"./decidim/vendor/social-share-button/email.svg": 91092,
	"./decidim/vendor/social-share-button/facebook.svg": 1968,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 91972,
	"./decidim/vendor/social-share-button/hacker_news.svg": 50904,
	"./decidim/vendor/social-share-button/linkedin.svg": 29010,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 71227,
	"./decidim/vendor/social-share-button/pinterest.svg": 5285,
	"./decidim/vendor/social-share-button/reddit.svg": 29704,
	"./decidim/vendor/social-share-button/telegram.svg": 62013,
	"./decidim/vendor/social-share-button/tumblr.svg": 60890,
	"./decidim/vendor/social-share-button/twitter.svg": 83793,
	"./decidim/vendor/social-share-button/vkontakte.svg": 63483,
	"./decidim/vendor/social-share-button/wechat.svg": 65894,
	"./decidim/vendor/social-share-button/whatsapp.svg": 71646,
	"./decidim/vendor/social-share-button/x.svg": 62860,
	"./decidim/vendor/social-share-button/xing.svg": 5516
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73296;